import React from 'react'

export const ArrowTriangleUp = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='14'
    height='7'
    viewBox='0 0 14 7'
    {...props}
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M7.00009 0.000503882C7.22809 0.000503902 7.45509 0.0775036 7.64009 0.232504L13.6401 5.2325C14.0641 5.5855 14.1221 6.2165 13.7681 6.6405C13.4151 7.0645 12.7851 7.1215 12.3601 6.7685L6.98909 2.2925L1.62709 6.6075C1.19709 6.9535 0.567091 6.8855 0.221091 6.4555C-0.124908 6.0255 -0.0569094 5.3965 0.373091 5.0495L6.37309 0.221504C6.55609 0.0745042 6.77809 0.000503862 7.00009 0.000503882Z'
      {...props}
    />
  </svg>
)